export default __webpack_public_path__ + "static/media/mp_check_big.fed5b4b3.svg";